import React, { useState, useEffect } from "react";
import axios from "axios";
import "./LegendaUsers.css";

const Legenda = () => {
    const [markers, setMarkers] = useState([]);

    useEffect(() => {
        const loadMarkers = async () => {
            const cachedMarkers = localStorage.getItem("markers");
            if (cachedMarkers) {
                setMarkers(JSON.parse(cachedMarkers));
                return;
            }

            try {
                const response = await axios.get(route("building-markers"));
                if (response.status === 200) {
                    setMarkers(response.data);
                }
            } catch (error) {
                console.error("Erro ao carregar marcadores:", error);
            }
        };

        loadMarkers();
    }, []);

    return (
        <div>
            <table className="table table-striped table-condensed legenda-mapa">
                <thead>
                    <tr>
                        <th colSpan="2" style={{ paddingBottom: 7 }}>
                            <span
                                className="font-weight-bold text-center"
                                style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
                            >
                                LEGENDA
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {markers.map((marker) => {
                        const randomNumber = Math.floor(Math.random() * (999999 - 100000)) + 100000;
                        const key = `${marker.status}.${marker.tipo}.${marker.status}.${randomNumber}`;

                        return (
                            <tr key={key}>
                                <td>
                                    <img src={marker.icon} alt={`${marker.tipo} icon`} />
                                </td>
                                <td>{`${marker.tipo} ${marker.padrao} ${marker.status}`}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default Legenda;